<template lang="pug">
.request
    .title(v-if="$slots.title || title")
        slot(name="title") {{ title }}
    slot
</template>

<script>
export default {
    props: {
        title: String
    }
}
</script>

<style lang="scss" scoped>
.request {
    width: 100%;

    .title {
        margin-right: 20px;
        width: 100%;
        font-size: 26px;
        line-height: 1.2;
        margin-bottom: 20px;
        font-weight: 300;
        position: relative;
        z-index: 2;
        user-select: text;
        cursor: text;
        font-family: 'Open Sans', sans-serif;
        color: rgba(0, 0, 0, 0.85);
        text-transform: uppercase;
    }
}
</style>


// WEBPACK FOOTER //
// Request.vue?74a97871